var map = {
	"./messages.en.yaml": [
		7315,
		[
			7315
		]
	],
	"./messages.es.yaml": [
		1260,
		[
			1260
		]
	],
	"./messages.fr.yaml": [
		7768,
		[
			7768
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 7663;
module.exports = webpackAsyncContext;